import React, { useEffect, useState } from 'react';
import { ShieldCheck, Clock, Check, CreditCard, Lock } from 'lucide-react';
export const PurchaseSection: React.FC = () => {
  const checkoutUrl = 'https://checkout.ebookpoint.shop/cart/59546533036113:1';
  // Countdown timer logic (15 minutes)
  const [timeLeft, setTimeLeft] = useState(15 * 60);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  return <section id="compra" className="w-full bg-slate-50 py-16 px-4 sm:px-6 lg:px-8 border-t border-slate-200 scroll-mt-4" data-id="element-142">
      <div className="max-w-4xl mx-auto bg-white rounded-3xl shadow-xl border border-slate-200 overflow-hidden" data-id="element-143">
        {/* Header Alert */}
        <div className="bg-red-600 text-white text-center py-3 px-4 flex items-center justify-center gap-2" data-id="element-144">
          <Clock className="w-5 h-5 animate-pulse" data-id="element-145" />
          <span className="font-bold text-sm sm:text-base" data-id="element-146">
            OFERTA POR TIEMPO LIMITADO: Termina en{' '}
            {minutes.toString().padStart(2, '0')}:
            {seconds.toString().padStart(2, '0')}
          </span>
        </div>

        <div className="p-6 sm:p-10 md:p-12" data-id="element-147">
          <div className="text-center mb-8" data-id="element-148">
            <h2 className="text-3xl sm:text-4xl font-extrabold text-slate-900 mb-4" data-id="element-149">
              Asegurá tu Atlas + Bonos Hoy
            </h2>
            <p className="text-slate-600 text-lg" data-id="element-150">
              Acceso inmediato de por vida. Pago único, sin suscripciones.
            </p>
          </div>

          <div className="flex flex-col md:flex-row gap-8 items-center justify-center mb-10" data-id="element-151">
            {/* Price Box */}
            <div className="bg-cyan-50 rounded-2xl p-8 border-2 border-cyan-200 text-center w-full md:w-1/2 relative" data-id="element-152">
              <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-cyan-600 text-white px-4 py-1 rounded-full text-xs font-bold tracking-wider" data-id="element-153">
                MEJOR VALOR
              </div>
              <p className="text-slate-500 font-medium mb-2" data-id="element-154">
                Precio Regular: <span className="line-through" data-id="element-155">$52.690</span>
              </p>
              <div className="flex items-start justify-center text-cyan-900 mb-2" data-id="element-156">
                <span className="text-2xl font-bold mt-2" data-id="element-157">$</span>
                <span className="text-6xl font-extrabold tracking-tighter" data-id="element-158">
                  19.990
                </span>
                <span className="text-xl font-bold mt-8 ml-1" data-id="element-159">ARS</span>
              </div>
              <p className="text-green-600 font-bold text-sm mb-6" data-id="element-160">
                Ahorrás $32.700 (62% OFF)
              </p>

              <a href={checkoutUrl} className="block w-full bg-green-600 hover:bg-green-700 text-white font-bold text-xl py-4 px-6 rounded-xl shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-1 mb-4" data-id="element-161">
                COMPRAR AHORA
              </a>

              <div className="flex items-center justify-center gap-2 text-xs text-slate-500" data-id="element-162">
                <Lock className="w-3 h-3" data-id="element-163" />
                <span data-id="element-164">Pago 100% seguro y encriptado</span>
              </div>
            </div>

            {/* What you get */}
            <div className="w-full md:w-1/2 space-y-4" data-id="element-165">
              <h3 className="font-bold text-lg text-slate-900 mb-4 border-b border-slate-100 pb-2" data-id="element-166">
                Resumen de tu compra:
              </h3>
              <ul className="space-y-3" data-id="element-167">
                <li className="flex items-start gap-3" data-id="element-168">
                  <div className="bg-green-100 p-1 rounded-full mt-0.5" data-id="element-169">
                    <Check className="w-4 h-4 text-green-700" data-id="element-170" />
                  </div>
                  <span className="text-slate-700 font-medium" data-id="element-171">
                    Atlas del Instrumentador (6 Capítulos)
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-172">
                  <div className="bg-green-100 p-1 rounded-full mt-0.5" data-id="element-173">
                    <Check className="w-4 h-4 text-green-700" data-id="element-174" />
                  </div>
                  <span className="text-slate-700 font-medium" data-id="element-175">
                    BONO 1: Guía Referencia Rápida
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-176">
                  <div className="bg-green-100 p-1 rounded-full mt-0.5" data-id="element-177">
                    <Check className="w-4 h-4 text-green-700" data-id="element-178" />
                  </div>
                  <span className="text-slate-700 font-medium" data-id="element-179">
                    BONO 2: Vocabulario Quirúrgico
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-180">
                  <div className="bg-green-100 p-1 rounded-full mt-0.5" data-id="element-181">
                    <Check className="w-4 h-4 text-green-700" data-id="element-182" />
                  </div>
                  <span className="text-slate-700 font-medium" data-id="element-183">
                    Acceso inmediato en PDF
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-184">
                  <div className="bg-green-100 p-1 rounded-full mt-0.5" data-id="element-185">
                    <Check className="w-4 h-4 text-green-700" data-id="element-186" />
                  </div>
                  <span className="text-slate-700 font-medium" data-id="element-187">
                    Actualizaciones de por vida
                  </span>
                </li>
              </ul>
            </div>
          </div>

          {/* Confidence callout */}
          <div className="text-center mb-6" data-id="element-188">
            <p className="text-2xl sm:text-3xl font-extrabold text-cyan-700" data-id="element-189">
              Ganá seguridad y confianza
            </p>
            <p className="text-slate-600 text-sm mt-1" data-id="element-190">
              Dejá de estudiar a ciegas. Entrá al quirófano sabiendo lo que
              hacés.
            </p>
          </div>

          {/* Guarantee */}
          <div className="flex flex-col sm:flex-row items-center gap-6 bg-slate-50 p-6 rounded-xl border border-slate-200" data-id="element-191">
            <ShieldCheck className="w-16 h-16 text-cyan-600 flex-shrink-0" data-id="element-192" />
            <div data-id="element-193">
              <h4 className="font-bold text-slate-900 mb-1" data-id="element-194">
                Garantía de Satisfacción de 7 Días
              </h4>
              <p className="text-sm text-slate-600" data-id="element-195">
                Si el atlas no te ayuda a sentirte más seguro en el quirófano,
                te devolvemos el 100% de tu dinero. Sin preguntas.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
};